/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { ICustomImageBannerViewProps } from './custom-image-banner';

export default (props: ICustomImageBannerViewProps) => {
    return (
        <div className={`container image-banner ${props.config.layout}-layout`}>
            <div className={`row ${props.config.imageAlignment === 'left' ? 'image-left' : ''}`}>
                <div className='image-banner__text-wrapper col-lg-5 col-12'>
                    {props.config.heading && props.config.heading.text
                        ? React.createElement(
                              props.config.heading.tag || 'h1',
                              {
                                  className: 'image-banner__title',
                                  contentEditable: false
                              },
                              props.config.heading.text
                          )
                        : ''}
                    {props.config.paragraph && (
                        <Msdyn365.RichTextComponent text={`<p className='image-banner__paragraph'>${props.config.paragraph}</p>`} />
                    )}
                    {props.config.cta && props.config.cta.label && props.config.cta.link ? (
                        <div className='ms-content-block__cta'>
                            <a className='msc-cta__primary' role='button' title={props.config.cta.label} href={props.config.cta.link}>
                                {props.config.cta.label}
                            </a>
                        </div>
                    ) : null}
                </div>
                <div className='image-banner__image-wrapper col-lg-7 col-12'>
                    <div className='image-banner__image-container'>
                        <img className='image-banner__image' src={props.config.image.src} />
                    </div>
                </div>
            </div>
        </div>
    );
};
